import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecipientsTableService {

  public newDataArr= new Subject<[]>();

  public srcFilterData$ = this.newDataArr.asObservable();

  public _dataStatus= new Subject<[]>();

  public dataStatus$ = this._dataStatus.asObservable();

  public _data= new Subject<[]>();

  public data$ = this._data.asObservable();

  constructor() { }

  public setFilteredData(ls): void {
    this.newDataArr.next(ls);
  }

  public dataStatus(ls): void {
    this._dataStatus.next(ls);
  }

  public data(ls): void {
    this._data.next(ls);
  }

  //Check {} object is Empty.
  public isEmpty(obj) {
    if(obj.length==0)
      return true;
    return false;
  }
}
